import Vue from "vue";
import Vuex from "vuex";
import AuthModule from "./modules/Auth.module";
import UserModule from "./modules/User.module";
import ConfigModule from "./modules/Config.module";
import ProjectModule from "./modules/Project.module";
import PlanModule from "./modules/Plan.module";
import MediaModule from "./modules/Media.module";
import CouponModule from "./modules/Coupon.module";
import PassportModule from "./modules/Passport.module";
import SubscriptionModule from "./modules/Subscription.module";
import TrackModule from "./modules/Track.module";

Vue.use(Vuex);
const store = new Vuex.Store({
	state: {
		loading: false,
		barColor: "rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)",
		barImage: "public/assets/ClapWay-light.svg",
		drawer: null
	},
	modules: {
		AuthModule,
		UserModule,
		ProjectModule,
		PlanModule,
		ConfigModule,
		PassportModule,
		CouponModule,
		MediaModule,
		SubscriptionModule,
		TrackModule
	},
	mutations: {
		SET_BAR_IMAGE(state, payload) {
			state.barImage = payload;
		},
		SET_DRAWER(state, payload) {
			state.drawer = payload;
		}
	}
});
export default store;

export const config = function(key, value) {
	store.commit(ConfigModule.types.SET, {
		key,
		value
	});
};
